import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/dynamic-form/constants/ItemsTypes';
import { get } from 'lodash';
import { AuditViewerService } from '../../services/audit-viewer.service';
import { AuditSearchRequestDTO } from '../../classes/audit-search-request';
import { AuditSearchResponseDTO } from '../../classes/audit-search-response';
import { AuditEventViewItem } from '../../classes/audit-event-view-item';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { BasicModalComponent } from '@ispm/layout/components/modals/basic-modal/basic-modal.component';
import { StringUtils } from '@ispm/shared/utils/String.utils';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { BasicModalLoaderPayload } from '@ispm/layout/classes/basic-modal-loader-payload';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';

@Component({
  selector: 'ispm-audit-viewer',
  templateUrl: './audit-viewer.component.html',
  styleUrls: ['./audit-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AuditViewerComponent implements OnInit {
  public auditSearchFormConfig: DynamicFormItem[] = [];
  public auditItemTableConfig: DynamicFormItem[] = [];
  public auditResponse: AuditSearchResponseDTO;
  public auditResponseStr: string;
  public columns: string[] = [];
  public auditViewItem: AuditEventViewItem[];

  private organizationMap: Map<string, any> = new Map();
  private practitionerMap: Map<string, any> = new Map();

  constructor(
    private auditViewerService: AuditViewerService,
    private ModalLoader: DynamicModalLoaderService,
    private userActionCreatorService: UserActionCreatorService
  ) {
  }

  ngOnInit() {
    this.auditSearchFormConfig.push(
      DynamicFormItem.builder('Organization', 'organization', ITEMS_TYPES.AUTOCOMPLETE)
        .setOptions('organization?name=$(searchTerm)&_count=10000|transform=name:display,id:code')
        .setAttributes({ '[minLength]': 3}),
      DynamicFormItem.builder('Practitioner', 'practitioner', ITEMS_TYPES.AUTOCOMPLETE)
        .setOptions( '/practitioner?name=$(searchTerm)|transform=name[0].text:display,id:code' ),
      DynamicFormItem.builder('Start Date', 'startDate', ITEMS_TYPES.DATEPICKER).setCssClass('percentage-item-33').setAttributes( { '[showTime]': 'true' , '[maxDate]': 'now'} ),
      DynamicFormItem.builder('End Date', 'endDate', ITEMS_TYPES.DATEPICKER).setCssClass('percentage-item-33').setAttributes({ '[showTime]': 'true', '[maxDate]': 'now'}) ,
      DynamicFormItem.builder( 'Page Number',  'pageNumber', ITEMS_TYPES.NUMBER ).setDefault( 1 ).setRegex( '^[0-9]+$' ).setAttributes( { 'min' : 1} ).setCssClass('percentage-item-33'),
    );

    this.auditItemTableConfig.push(
      DynamicFormItem.builder('Genomics Organization Id', 'organizationId', ITEMS_TYPES.TEXT ),
      DynamicFormItem.builder('Genomics User Id', 'userId', ITEMS_TYPES.TEXT )
    );

    this.columns = ['organization Id', 'user Id', 'user Role', 'npi', 'application Version', 'event Action', 'event Display', 'date Time', 'audit EventContainer'];



  }

  private loadMaps( organizationIds, userIds ): Promise<any> {
    const promises = [];
    if ( organizationIds && organizationIds.length > 0) {
      const orgsPromise = this.userActionCreatorService.getOrganizations(organizationIds).toPromise();
      promises.push( orgsPromise );
      orgsPromise.then(organizations => {
          for (const i of organizations) {
            this.organizationMap.set(i.id, i);
          }
        });
    }
    if ( userIds && userIds.length > 0) {
      const usersPromise = this.userActionCreatorService.getPractitioners(userIds).toPromise();
      promises.push( usersPromise );
      usersPromise.then(practitioners => {
          for (const i of practitioners) {
            this.practitionerMap.set(i.id, i);
          }
        });

    }
    // let organizations = this.userActionCreatorService.getOrganizations( organizationIds );
    // TODO check if all promices are empty
    return Promise.all(promises );
  }

  private findOrganizationNameById(organizationId: string): string {
    if ( !this._isUUID( organizationId ) ) {
      return '';
    }
    let organization = null;
    if ( this.organizationMap.has( organizationId ) ) {
      organization = this.organizationMap.get(organizationId);
    }
    if ( !!organization ) {
      return organization.name;
    } else {
      return '';
    }
  }

  private findUserNameByPractitionerId(userId: string): string {
    if (!this._isUUID( userId )) {
      return '';
    }

    const practitioner = this.practitionerMap.get(userId);

    if (!!practitioner) {
      return get( practitioner, 'name[0].text');
    }

    return '';
  }

  private _isUUID(id): boolean {
    return id != null && StringUtils.isUUID(id);
  }

  /**
   * endDate: "18 Apr 2019"
   organization: {name: "York Hospital - Pathology", id: "001451d8-ad7a-11e8-ae24-1209f4da0cf4"}
   pageNumber: 1
   practitioner: {text: "TYLER REED GREEN", id: "13d527cc-88b1-11e7-b53e-122260a1fc08"}
   startDate: "18 Apr 2019"
   *
   */
  onItemClick(event) {
    console.log(event);
    this.loadModal(event.auditEventContainerJson);
  }

  searchAudit($event) {
    console.log($event);
    const auditSearchRequest = new AuditSearchRequestDTO();
    auditSearchRequest.organizationId = get($event, 'organization.id', '');
    auditSearchRequest.userId = get($event, 'practitioner.id', '');
    auditSearchRequest.startDateTime = this.convertDate( $event.startDate );
    auditSearchRequest.endDateTime = this.convertDate( $event.endDate );
    auditSearchRequest.page = get( $event, 'pageNumber', '' );

   if ( !this.isAuditSearchRequestValid( auditSearchRequest  ) ) {
     this.loadModalMessage( 'The one of fields Organization or User or start and end date fields must contain value' );
     return;
   }


    this.auditViewerService.searchAudits( auditSearchRequest )
      .subscribe(auditResponse => {

        // calculate the unique index for each item at the auditResponse
        // the unique index is calculated generally to all pages by the count of items per a paging
        const maxCountItems: number = auditSearchRequest.count ? auditSearchRequest.count : 100000;
        let startItemIndex = auditSearchRequest.page * maxCountItems + 1;

        this.auditResponse = auditResponse;

        // load organization map
        const orgIds = new Set();
        const userIds = new Set();
        for ( const i of auditResponse.auditEventViewItem ) {
          if ( this._isUUID( i.organizationId ) ) {
            orgIds.add(i.organizationId);
          }
          if ( this._isUUID( i.userId ) ) {
            userIds.add( i.userId );
          }
        }

        this.loadMaps( Array.from( orgIds.values() ), Array.from( userIds.values() ) )
          .then(() => {
            this.auditResponseStr = JSON.stringify( auditResponse );
            auditResponse.auditEventViewItem.forEach(item => {
              item.auditEventContainerJson = JSON.stringify(item.auditEventContainer, null, 2);
              item.organizationName = this.findOrganizationNameById( item.organizationId );
              item.userName = this.findUserNameByPractitionerId( item.userId );
              item.itemIndex = startItemIndex++;
            });
            this.auditViewItem = auditResponse.auditEventViewItem;

            // console.info("range: " + this.auditViewItem[0].itemIndex + " - " + this.auditViewItem[19].itemIndex);
          });
        this.auditViewItem = [];

      });
  }

  convertDate(  date: string) {
    if ( !!date ) {
      date = new Date( date ).toISOString();
    }
    return date;
  }

  loadModal( context ) {
     this.ModalLoader.popupModal(BasicModalComponent, new BasicModalLoaderPayload('json data',  context ), ModalTypes.INFO);
  }

  loadModalMessage( message ) {
    this.ModalLoader.popupModal(BasicModalComponent, new BasicModalLoaderPayload('Message',  message ), ModalTypes.INFO);
  }

  private isAuditSearchRequestValid(auditSearchRequest: AuditSearchRequestDTO) {
    return !!auditSearchRequest.userId ||
      !!auditSearchRequest.organizationId
      || (!!auditSearchRequest.startDateTime && !!auditSearchRequest.endDateTime);
  }
}


